import { CHANGE_DATE_REQUEST_STATUS } from '../../calendar/constants/ChangeDateRequestConstants';

export const CHANGE_DATE_REQUEST_STATUS_DISPLAY_NAMES_MAP = new Map([
  [CHANGE_DATE_REQUEST_STATUS.PENDING_ADMIN_APPROVAL, 'Pending Review'],
  [CHANGE_DATE_REQUEST_STATUS.PENDING_FDA_APPROVAL, 'Pending Review'],
  [CHANGE_DATE_REQUEST_STATUS.APPROVED, 'Approved'],
  [CHANGE_DATE_REQUEST_STATUS.DECLINED, 'Declined']
]);

export const COMMENT_MIN_LENGTH = 25;
export const COMMENT_MAX_LENGTH = 1000;
